(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-standard"]) return;
  try {
    

  const ttScrollCollectionResults = () => {

    const url = new URL(window.location.href);

    const hasFilter = Array.from(url.searchParams.keys()).some(
      (key) => key.startsWith('filter.')
    );

    /*
     * When a type card applies a collection filter,
     * automatically move the visitor to the product results.
     */
    if (hasFilter) {

      const results =
        document.getElementById('ResultsList') ||
        document.querySelector('results-list');

      if (results) {
        setTimeout(() => {
          results.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }, 150);
      }

      return;
    }


    /*
     * Preserve normal anchor behavior for other links.
     */
    if (url.hash) {

      const target = document.getElementById(
        url.hash.slice(1)
      );

      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }

    }

  };


  document.addEventListener(
    'DOMContentLoaded',
    ttScrollCollectionResults,
    { once: true }
  );

  document.addEventListener(
    'shopify:section:load',
    ttScrollCollectionResults
  );


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
